let ipcRenderer = null;
if (window && window.require) {
    ipcRenderer = window.require("electron").ipcRenderer;
}
/**
 * 打开应用窗口
 * @param appCode 应用标识码/窗口标识
 * @param url 应用URL
 */
export let openWin = (appCode, url) => {
    // console.log("打开鉴权窗口");
    // console.log(ipcRenderer)
    if (ipcRenderer) {
        ipcRenderer.send("create-app-win", appCode, url);
    } else {
        window.open(url, appCode, true)
    }
};
/**
 * 关闭应用窗口
 * @param appCode 应用标识码/窗口标识
 */
export let closeWin = (appCode) => {
    if (ipcRenderer) {
        // console.log(ipcRenderer)
        ipcRenderer.send("close-app-win", appCode);
    }
};
/**
 * 显示应用个窗口
 * @param appCode 应用标识码/窗口标识
 */
export let showWin = (appCode) => {
    if (ipcRenderer)
        ipcRenderer.send("show-app-win", appCode);
};
/**
 * 加载应用窗口
 * @param appCode 应用表示/窗口标识
 * @param url 应用URL
 */
export let loadWin = (appCode, url) => {
    if (ipcRenderer)
        ipcRenderer.send("load-app", appCode, url);
};